import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionFeatures/SectionFeatures.module.scss';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {
  return (
    <section className={cn('features')}>
      <div className={cn('container')}>

        <ul className={cn('features__list')}>
          <li className={cn('features__list-item')}>
            <h4 className={cn('features__list-item-heading')}>
              Logistics Explorer
            </h4>
            <p className={cn('features__list-item-paragraph')}>
              <Link className={cn('features__link')} href='/digital-tools/logistics-explorer'>Logistics Explorer</Link> is
              a powerful tool for route optimisation and cost analysis,
              providing users with the ability to compare different shipping options and select
              the most efficient routes. By analysing various logistics scenarios, users can
              make informed decisions that ensure timely delivery of containers while minimising
              costs. The tool's capability to provide detailed transit times and costs for
              multiple routes helps users avoid potential delays that could lead to demurrage
              and detention charges.
            </p>
          </li>
          <li className={cn('features__list-item')}>
            <h4 className={cn('features__list-item-heading')}>
              Ship Schedules
            </h4>
            <p className={cn('features__list-item-paragraph')}>
              This digital tool rovides users with comprehensive and up-to-date information
              on vessel schedules, allowing freight forwarders and NVOCCs to plan their
              shipments accurately. By having access to precise departure and arrival times,
              users can better coordinate their logistics operations to ensure timely pick-up
              and delivery of containers. <Link className={cn('features__link')} href='https://www.searates.com/integrations/ship-schedules/'>Ship Schedules</Link> enables
              proactive planning, reducing the risk of containers sitting idle at ports, thereby minimising the chances of
              incurring demurrage and detention charges. The tool's real-time updates also
              help users adjust their plans in response to any schedule changes, further
              enhancing their ability to avoid additional costs.
            </p>
          </li>
          <li className={cn('features__list-item')}>
            <h4 className={cn('features__list-item-heading')}>
              The Evolving Landscape of Demurrage and Detention
            </h4>
            <p className={cn('features__list-item-paragraph')}>
              Awareness of Demurrage and Detention issues within the shipping industry
              has risen significantly in recent years, prompting authorities like the
              Federal Maritime Commission (FMC) to investigate the fairness and
              reasonableness of these charges. This investigation stems partly from
              the sharp spike in these fees witnessed during the pandemic. In fact,
              the <Link className={cn('features__link')} href='https://www.fmc.gov/fact-finding-29/'>FMC's Fact Finding 29</Link> revealed
              nine major carriers collected around $12.9 billion in detention and demurrage
              charges just between April 2020 and March 2023.
            </p>
            <p className={cn('features__list-item-paragraph')}>
              The investigation into these practices by the Federal Maritime Commission,
              along with initiatives like Fact Finding 29 recommendations and the Advance
              Notice of Proposed Rulemaking in February 2022, demonstrates a proactive
              approach toward addressing concerns and ensuring greater transparency within
              the industry. These actions aim to create a fairer system that balances
              the interests of carriers, freight forwarders, and other stakeholders within
              the maritime supply chain.
            </p>
          </li>
          <li className={cn('features__list-item')}>
            <h4 className={cn('features__list-item-heading')}>
              OSRA 22 Final Rule in 2024
            </h4>
            <p className={cn('features__list-item-paragraph')}>
              The <Link className={cn('features__link')} href='https://www.bts.gov/osra'>Ocean Shipping Reform Act</Link> (OSRA) 
              of 2022, finalised in 2024, is primarily designed to stimulate containerised 
              exports and protect the interests of U.S. exporters by increasing control 
              and regulation of containerised traffic by shipping lines operating in U.S. 
              ports. The Act also mandates the control and independent assessment of 
              bills for demurrage and detention charges imposed by shipping lines 
              on U.S. shippers.
            </p>
          </li>
        </ul>

      </div>
    </section>
  );
};

export default SectionFeatures;